import { ListEvent } from '../../../constants';

export enum ListPrivateWebsocketEvent {
  DocumentQueueAssignedEvent = ListEvent.DocumentQueueAssignedEvent,
  NoDocumentsToAssignEvent = ListEvent.NoDocumentsToAssignEvent,
}
